<div class="wk-insert-other-document-link">
  <header>
    <h3 class="mb-0" mat-dialog-title>
      {{ 'ADF_INSERT_LINK.LINK_TO_ANOTHER_DOCUMENT_TAB' | translate }}
    </h3>
    <div class="search-panel">
      <mat-dialog-content class="search-panel__subtitle">
        {{ 'ADF_INSERT_LINK.ANOTHER_DOCUMENT_SUBTITLE' | translate }}
      </mat-dialog-content>
      <form class="search-panel__form">
        <wk-input class="wk-input">
          <input
            class="wk-field-input search-document-input"
            autocomplete="off"
            placeholder="{{
              'ADF_INSERT_LINK.ANOTHER_DOCUMENT_SEARCH_LABEL' | translate
            }}"
            type="text"
            [(ngModel)]="searchDocument"
            (keyup.enter)="search()"
            [ngModelOptions]="{ standalone: true }"
            id="searchDocument"
            focus-me
          />
        </wk-input>
        <img
          class="padding-left c-pointer search-document-icon"
          alt="Search"
          src="assets/images/search.svg"
          (click)="search()"
          (keyup)="search()"
        />
      </form>
    </div>
  </header>

  <section class="folder-container">
    <div class="wk-breadcrumb">
      <wk-breadcrumb
        *ngIf="!searchFiles"
        [folderNode]="breadCrumbNode"
        (navigate)="onBreadcrumbNavigate($event)"
      >
      </wk-breadcrumb>
    </div>
    <div class="folder-navigation" *ngIf="!searchFiles">
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-progress-spinner
          [color]="'primary'"
          [mode]="'indeterminate'"
          diameter="70"
        >
        </mat-progress-spinner>
      </div>
      <wk-media-tree-view-list
        [node]="node"
        *ngIf="!isLoading"
        [mediaType]="mediaType"
        [forbiddenType]="forbiddenType"
        [currentSite]="currentSite"
      ></wk-media-tree-view-list>
    </div>

    <div class="searchResults" *ngIf="searchFiles">
      <div class="searchResultsHeading">
        {{ 'ADF_INSERT_LINK.SEARCH_RESULTS' | translate }}
      </div>
      <div class="folder-navigation">
        <div *ngIf="spinner" class="loading-spinner">
          <mat-progress-spinner
            [color]="'primary'"
            [mode]="'indeterminate'"
            diameter="70"
          >
          </mat-progress-spinner>
        </div>
        <div *ngIf="!spinner">
          <div *ngFor="let file of resultFiles">
            <div class="parent-wrapper">
              <div
                class="parent"
                (click)="onDocumentSelected($event, file)"
                (keyup)="onDocumentSelected($event, file)"
              >
                <div class="child">
                  <button
                    mat-icon-button
                    id="{{ 'button-' + file.entry.name }}"
                  >
                    <span class="file wk-icon-file"></span>
                    <div class="adf-tree-view-label">
                      {{ file.entry.name }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<footer class="action-buttons">
  <button class="wk-button wk-button-text" (click)="closeDialog()">
    {{ 'ADF_INSERT_LINK.CANCEL_BUTTON' | translate }}
  </button>
  <button
    class="wk-button"
    type="submit"
    [disabled]="isDisabled()"
    (click)="addLinkSelected()"
  >
    {{ 'ADF_INSERT_LINK.LINK_TO_ANOTHER_DOCUMENT_TAB' | translate }}
  </button>
</footer>
